import { useState } from 'react';

import { MoonIcon, SunIcon } from '@radix-ui/react-icons';

import { Button } from '@/components/ui/button';
import { getTheme, toggleTheme, type Theme } from '@/shared/lib/theme';

/** Light/dark switch — mirrors the prism-landing toggle. Lives in the header. */
export function ThemeToggle() {
  const [theme, setThemeState] = useState<Theme>(getTheme);

  return (
    <Button
      variant="ghost"
      size="sm"
      aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      onClick={() => setThemeState(toggleTheme())}
      className="text-muted-foreground hover:text-foreground hover:bg-secondary/30 rounded-lg cursor-pointer"
    >
      {theme === 'light' ? <MoonIcon className="h-4 w-4" /> : <SunIcon className="h-4 w-4" />}
    </Button>
  );
}
